export default {
    REACT_REACT_APP : 'Course Membership',
    REACT_APP_BASE_URL : "https://bridge.flexifunnels.com/api/",
    REACT_APP_BUCKET_URL : "https://membershipdata.flexifunnels.com",
    REACT_CHAT_APIURL : 'https://stats.flexifunnels.com/'
};
// https://stats.flexifunnels.com/